<template>
    <div>
        <template v-if="corporate_account_management === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <div class="page-top float-left">
                    <h1 class="m-0">Mobilizer Login</h1>
                </div>
            </div>
            <div class="corporate-main">
                <div class="corporate-content">
                    <div class="login-mobilizer-inner p-5">
                        <img class="logo mb-3" src="/images/simsim-logo-colored.png" alt="" />
                        <form @submit.prevent="corpLogin">
                            <div class="moblizer-account-login">
                                <span class="title mb-2"> Sign in to your corporate <span class="highlight-color">SimSim</span> ﻿Account </span>
                                <div class="form-group mb-2">
                                    <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }" readonly="">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                                <div class="form-group mb-2">
                                    <input v-model="form.password" type="password" name="password" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }" placeholder="Password">
                                    <has-error :form="form" field="password"></has-error>
                                </div>
                                <span class="title mb-2"> Do you really want to proceed? </span>
                                <div class="row normal-ib-space">
                                    <div class="col"><router-link to="/companySalaryDashboard" class="btn btn-primary"> Cancel</router-link></div>
                                    <div class="col"> <button :disabled="form.busy" class="btn btn-primary proceed active"> Proceed </button> </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="corporate_account_management === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="corporate_account_management === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    email : '',
                    password : '',
                }),
                corporate_account_management: null
            };
        },
        methods: {
            corpLogin(){
                this.$Progress.start();
                this.form.post("/api/corporateLogin")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','You are successfully logged in.');
                            this.$router.push('/transactionHistory');
                        }else if(res.data.status == 401){
                            this.$Progress.fail();
                            this.showToastBox('error',res.data.msg);
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','System is not responding! Please try again later.');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getCorpLoginData(){
                axios.get('/api/getCorpLoginData')
                .then(res => {
                    if(res.status == 200){
                        this.form.email = res.data.company.email;
                        // this.$Progress.finish();
                    }else{
                        // this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    // this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            }
        },
        mounted() {
            // this.$Progress.start();
			this.can('corporate_account_management').then(result => {
                this.corporate_account_management = result.corporate_account_management;
            }).then(result => {
                if(this.corporate_account_management == true){
                    this.getCorpLoginData();
                    // this.$Progress.finish();
                }else{
                    // this.$Progress.finish();
                }
            });

        },
    }
</script>
